var BOLD = BOLD || {};
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.MS = BOLD.BMS.MS || {};

BOLD.BMS.MS.Cart = function($) {
  "use strict";

  var cart = null;
  var settings = {};
  
  var gst = null;

  function init(data, options) {
    data = data || {};
    cart = data.cart || {};

    $.extend(true, settings, options);

    // Set initial values
    gst = BOLD.BMS.MS.GstSwitcher.gst;
    
    bindEvents();

    setPrices();
  }

  function initAsync(data, options) {
    getCart(data, options);
  }

  function bindEvents() {
    BOLD.common.eventEmitter.on("BOLD_COMMON_gst_changed", function (payload) {
      setPrices();
    });

    BOLD.common.eventEmitter.on("BOLD_COMMON_cart_changed", BOLD.BMS.Common.debounce(
      function(payload) {
        cart = payload.cart;

        setPrices();
      }, 500, true
    ));
  }

  function setPrices() {
    var fixedCart = BOLD.common.cartDoctor.fix(cart);
    
    var totalPrice = 0;
    fixedCart.items.forEach(function(item) {
      totalPrice += setPrice(item);
    });

    setCartTotal(totalPrice);
  }

  function setCartTotal(totalPrice) {
    var cartTotals = document.querySelectorAll(".cart-total .money, .cart-title-total .money");
    cartTotals.forEach(function(cartTotal) {
      cartTotal.textContent = formatMoney(totalPrice);
    });
  }

  function setPrice(item) {
    var target = document.querySelector("[data-cartitem-key='" + item.key + "']");
    var totalPrice = 0;
    
    if (target) {
      var lineItem = BOLD.BMS.CSPQB.fixVariant(item);
      var cost = (gst.isIncluded && item.taxable) ? BOLD.BMS.CSPQB.calculateGstPrice(lineItem.price) : lineItem.price;
  
      var price = target.querySelector(".cart-item--content-price .money");
      if (price) price.textContent = formatMoney(cost)

      var total = target.querySelector(".cart-item--total .money");
      totalPrice = cost * item.quantity;
      if (total) total.textContent = formatMoney(totalPrice);
    }

    return totalPrice;
  }

  function getCart(data, options) {
    data = data || {};
    var url = location.protocol + "//" + location.hostname + location.pathname + ".js";

    $.getJSON(url)
      .done(function(result) {
        data.cart = result;
        init(data, options);
      })
      .fail(function(err) {
        console.error(err);
      }
    );
  }

  function formatMoney(cents, style){
    if(window.Shopify && Shopify.formatMoney){
      style = style || (BOLD.common && BOLD.common.Shopify ? BOLD.common.Shopify.shop.money_format : '${{amount}}')
      return Shopify.formatMoney(cents, style);
    }
    else{
      var currency = (BOLD.common && BOLD.common.Shopify ? BOLD.common.Shopify.shop.currency : 'NZD')
      return (cents * 0.01).toLocaleString(undefined, {style: 'currency', currencyDisplay: 'symbol', currency: currency})
    }
  }

  return {
    init: init,
    initAsync: initAsync
  };

}(BOLD.jQuery || jQuery);